[
  {
    "id": "MET-M8-L303-001",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Hoeveel dl is 0,02 hl?",
    "options": ["20 dl", "200 dl", "2 dl", "2.000 dl"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-HL-DL",
    "explanation": "1 hl = 100 liter = 1.000 dl. 0,02 × 1.000 = 20 dl.",
    "distractorExplanations": {
      "1": "Je deed ×10.000.",
      "2": "Je deed ×100.",
      "3": "Je deed ×100.000."
    }
  },
  {
    "id": "MET-M8-L303-002",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Een rechthoekig veld is 1,2 ha groot. De lengte is 150 m. Wat is de breedte?",
    "options": ["80 m", "8 m", "800 m", "120 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-HA-BREEDTE",
    "explanation": "1,2 ha = 12.000 m². Breedte = 12.000 : 150 = 80 m.",
    "distractorExplanations": {
      "1": "Je vergat ha om te rekenen naar m².",
      "2": "Je deed 12.000 : 15.",
      "3": "Je deed 12.000 : 100."
    }
  },
  {
    "id": "MET-M8-L303-003",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Reken om: 3.600 seconden = ... uur",
    "options": ["1 uur", "0,5 uur", "2 uur", "10 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "tijd",
    "familyId": "MET-SEC-UUR",
    "explanation": "1 uur = 60 minuten = 3.600 seconden.",
    "distractorExplanations": {
      "1": "Dat is 1.800 seconden.",
      "2": "Dat is 7.200 seconden.",
      "3": "Dat is 36.000 seconden."
    }
  },
  {
    "id": "MET-M8-L303-004",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Wat is de omtrek van een cirkel met diameter 10 cm? (π = 3,14)",
    "options": ["31,4 cm", "314 cm", "15,7 cm", "62,8 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMTREK-CIRKEL",
    "explanation": "Omtrek = π × diameter = 3,14 × 10 = 31,4 cm.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je gebruikte de straal (5) in plaats van de diameter.",
      "3": "Je deed 2 × diameter × π."
    }
  },
  {
    "id": "MET-M8-L303-005",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Reken om: 3,5 dm³ = ... cc",
    "options": ["3.500 cc", "350 cc", "35 cc", "35.000 cc"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-DM3-CC",
    "explanation": "1 dm³ = 1.000 cm³ = 1.000 cc. 3,5 × 1.000 = 3.500 cc.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je deed ×10.",
      "3": "Je deed ×10.000."
    }
  },
  {
    "id": "MET-M8-L303-006",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Wat is de oppervlakte van een cirkel met straal 5 cm? (π = 3,14)",
    "options": ["78,5 cm²", "31,4 cm²", "157 cm²", "15,7 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-CIRKEL",
    "explanation": "Oppervlakte = π × r² = 3,14 × 25 = 78,5 cm².",
    "distractorExplanations": {
      "1": "Je berekende de omtrek (π × diameter).",
      "2": "Je deed π × r² × 2.",
      "3": "Je deed π × r (zonder kwadraat)."
    }
  },
  {
    "id": "MET-M8-L303-007",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Een vat bevat 3 hl bier. Hoeveel glazen van 250 ml kun je vullen?",
    "options": ["1.200 glazen", "120 glazen", "12.000 glazen", "300 glazen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-HL-GLAZEN",
    "explanation": "3 hl = 300 liter = 300.000 ml. 300.000 : 250 = 1.200 glazen.",
    "distractorExplanations": {
      "1": "Je vergat om te rekenen naar ml.",
      "2": "Je deed 300.000 : 25.",
      "3": "Je deed 300 : 1."
    }
  },
  {
    "id": "MET-M8-L303-008",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Reken om: 0,15 km² = ... m²",
    "options": ["150.000 m²", "15.000 m²", "1.500 m²", "1.500.000 m²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-KM2-M2",
    "explanation": "1 km² = 1.000.000 m². 0,15 × 1.000.000 = 150.000 m².",
    "distractorExplanations": {
      "1": "Je deed ×100.000.",
      "2": "Je deed ×10.000.",
      "3": "Je deed ×10.000.000."
    }
  },
  {
    "id": "MET-M8-L303-009",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Een bak is 2,5 m lang, 1,2 m breed en 0,8 m hoog. Hoeveel liter past erin?",
    "options": ["2.400 liter", "240 liter", "24.000 liter", "4,5 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BAK-M8",
    "explanation": "Inhoud = 2,5 × 1,2 × 0,8 = 2,4 m³. 2,4 × 1.000 = 2.400 liter.",
    "distractorExplanations": {
      "1": "Je vergat ×1.000.",
      "2": "Je deed ×10.000.",
      "3": "Je telde de maten op."
    }
  },
  {
    "id": "MET-M8-L303-010",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Wat is de omtrek van een cirkel met straal 7 cm? (π = 3,14)",
    "options": ["43,96 cm", "21,98 cm", "153,86 cm", "87,92 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMTREK-CIRKEL-R7",
    "explanation": "Omtrek = 2 × π × r = 2 × 3,14 × 7 = 43,96 cm.",
    "distractorExplanations": {
      "1": "Je deed π × r (zonder ×2).",
      "2": "Je berekende de oppervlakte (π × r²).",
      "3": "Je deed 2 × π × r × 2."
    }
  },
  {
    "id": "MET-M8-L303-011",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Een auto rijdt 108 km/u. Hoeveel meter per seconde is dat?",
    "options": ["30 m/s", "10,8 m/s", "108 m/s", "18 m/s"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-KMU-MS-108",
    "explanation": "Van km/u naar m/s: delen door 3,6. 108 : 3,6 = 30 m/s.",
    "distractorExplanations": {
      "1": "Je deelde door 10.",
      "2": "Je zette niets om.",
      "3": "Je deelde door 6."
    }
  },
  {
    "id": "MET-M8-L303-012",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Hoeveel hectare is 0,35 km²?",
    "options": ["35 ha", "3,5 ha", "350 ha", "0,35 ha"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-KM2-HA",
    "explanation": "1 km² = 100 ha. 0,35 × 100 = 35 ha.",
    "distractorExplanations": {
      "1": "Je deed ×10.",
      "2": "Je deed ×1.000.",
      "3": "Je zette niets om."
    }
  },
  {
    "id": "MET-M8-L303-013",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Een cilinder heeft een diameter van 20 cm en een hoogte van 30 cm. Wat is de inhoud? (π = 3,14)",
    "options": ["9.420 cm³", "18.840 cm³", "4.710 cm³", "94.200 cm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-CILINDER-M8",
    "explanation": "Straal = 10 cm. Grondvlak = π × r² = 3,14 × 100 = 314 cm². Inhoud = 314 × 30 = 9.420 cm³.",
    "distractorExplanations": {
      "1": "Je gebruikte de diameter in plaats van de straal.",
      "2": "Je deed de inhoud : 2.",
      "3": "Je deed 314 × 300."
    }
  },
  {
    "id": "MET-M8-L303-014",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Reken om: 7.200 seconden = ... minuten",
    "options": ["120 minuten", "72 minuten", "720 minuten", "12 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "tijd",
    "familyId": "MET-SEC-MIN",
    "explanation": "1 minuut = 60 seconden. 7.200 : 60 = 120 minuten.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.",
      "3": "Je deelde door 600."
    }
  },
  {
    "id": "MET-M8-L303-015",
    "module": "Metriek",
    "difficulty": 303,
    "question": "Een regenton vangt 0,2 m³ water op. Hoeveel emmers van 10 liter kun je vullen?",
    "options": ["20 emmers", "2 emmers", "200 emmers", "10 emmers"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-REGENTON",
    "explanation": "0,2 m³ = 200 liter. 200 : 10 = 20 emmers.",
    "distractorExplanations": {
      "1": "Je vergat om te rekenen naar liter.",
      "2": "Je deed 200 : 1.",
      "3": "Je deed 200 : 20."
    }
  }
]